// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7927":"56dc4e11","9342":"2d82ed15","9984":"2d82ed15"}[chunkId] + ".chunk.css";
};